export default "__VITE_ASSET__CHRX_Uh$__"